module.exports = __webpack_public_path__ + "img/symbol_1.cd014f8c.png";